import API from 'utils/API';
import http from 'utils/http';
import MemoryCache from 'utils/MemoryCache';
import { language } from 'utils/i18n';
import security from 'stores/security';
import type { CurrentUser } from 'types/UserStatus';

const REGION = 'USA';
const ACCOUNT_TYPE = 'ib'; // 暂时只有一种类型 无论是否登录都需要传account_type

const cache = new MemoryCache();

class HelpStore {
    getClearingAndLoginUser(currentUser: CurrentUser) {
        if (!currentUser) {
            currentUser = security.currentUser;
        }

        return {
            login_user: Number(currentUser.isLogin),
            clearing: currentUser.isIBClearing ? 'ib' : 'marsco'
        };
    }

    getHelpList(lang = language, currentUser: CurrentUser = security.currentUser) {
        const params = {
            lang,
            region: REGION,
            account_type: ACCOUNT_TYPE,
            // 接口文档说明，login_user参数为1或0，类型为string
            ...this.getClearingAndLoginUser(currentUser)
        };

        const key = `helplist:${Object.values(params).toString()}`;

        return cache.has(key)
            ? Promise.resolve(cache.get(key))
            : http.get(API.CUSTOMER.help.getList(), { params }).then(resp => cache.set(key, resp.data, 3600));
    }

    getListDetail(id, lang = language, currentUser: CurrentUser = security.currentUser) {
        const params = {
            lang,
            ...this.getClearingAndLoginUser(currentUser)
        };

        const cacheKey = `help:${id}:${Number(currentUser.isLogin)}`;

        return cache.has(cacheKey)
            ? Promise.resolve(cache.get(cacheKey))
            : http
                  .get(API.CUSTOMER.help.getListDetail(id), { params })
                  .then(resp => cache.set(cacheKey, resp.data, 3600));
    }

    getQuestion(lang = language, currentUser: CurrentUser = security.currentUser) {
        const params = {
            lang,
            ...this.getClearingAndLoginUser(currentUser)
        };

        return http.get(API.CUSTOMER.help.getQuestion(), { params });
    }

    getSearchContent(keyword, lang = language, currentUser: CurrentUser = security.currentUser) {
        const params = {
            lang,
            region: REGION,
            account_type: ACCOUNT_TYPE,
            keyword,
            ...this.getClearingAndLoginUser(currentUser)
        };

        return http.get(API.CUSTOMER.help.search(), { params });
    }
}

export default new HelpStore();
